export default __webpack_public_path__ + "static/media/icon-weight.645329b6.svg";